import request from '../helpers/request'
import helpers from "../helpers/common";

const news = {}

news.getData = async (filters = {}) => {
    return request.get('/news', filters, false)
}

news.get = async (id) => {
    return request.get('/news/get', {id}, false)
}

news.getLatest = async (limit = 5) => {
    return request.get('/news/latest', {limit}, false)
}

news.add = async (data) => {
    return request.post('/news/add', {
        title: data.title,
        content: data.content,
        enabled: data.enabled !== undefined ? data.enabled : true
    }, true)
}

news.edit = async (data) => {
    return request.put('/news/edit', {
        id: data.id,
        title: data.title,
        content: data.content,
        enabled: data.enabled
    }, true)
}

news.delete = async (id) => {
    return request.delete('/news/delete', {id}, true)
}

news.methodValidator = {}
news.methodValidator.add = (fields, errors = {}) => {
    if (!fields.title || !fields.title.trim()) {
        errors.title = 'Title is required'
    } else if (fields.title.length > 500) {
        errors.title = 'Title is too long (max 500 characters)'
    }
    if (!fields.content || !fields.content.trim()) {
        errors.content = 'Content is required'
    }
    return errors
}

news.methodValidator.edit = (fields, errors = {}) => {
    if (fields.title !== undefined) {
        if (!fields.title || !fields.title.trim()) {
            errors.title = 'Title cannot be empty'
        } else if (fields.title.length > 500) {
            errors.title = 'Title is too long (max 500 characters)'
        }
    }
    if (fields.content !== undefined) {
        if (!fields.content || !fields.content.trim()) {
            errors.content = 'Content cannot be empty'
        }
    }
    return errors
}

export default news

